let textContainer = document.querySelector('.read-more__grabber')
let readMoreButton = document.querySelector('#collapsible-read-more__button')
let readLessButton = document.querySelector('#collapsible-read-less__button')


const openCollapsible = () => {
    textContainer.style.cssText = 'max-height:2000px';
    readMoreButton.style.display = 'none';
    readLessButton.style.display = 'flex';
    textContainer.classList.remove('fadeoverlay');


}

const closeCollapsible = () => {
    textContainer.style.cssText = 'max-height:200px';
    readMoreButton.style.display = 'flex';
    readLessButton.style.display = 'none';
    textContainer.classList.add('fadeoverlay');


}
  
readMoreButton.addEventListener('click', openCollapsible)
readLessButton.addEventListener('click', closeCollapsible)